import { Box, SxProps, Theme, Typography } from '@mui/material';
import React from 'react';
import TranslationHelper from '../../../helpers/TranslationHelper';

interface IOwnProps {
    message: string;
    children?: React.ReactNode;
    typographySx?: SxProps<Theme>;
}

const PlayerMessage = ({ message, children, typographySx }: IOwnProps) => {
    return (
        <Box
            sx={{
                width: '100%',
                height: 300,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <Typography sx={typographySx}>
                {TranslationHelper.translate(message)}
            </Typography>
            {children}
        </Box>
    );
};

export default PlayerMessage;
